import { useTheme } from "styled-components";

import { useUserProductsQuery } from "@sso/apis/userProducts";
import { ProductCard } from "@sso/components/ProductCard";
import { Button } from "@sso/ui/Button";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { ColumnContainer, RowContainer } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

export const Products = () => {
  const theme = useTheme();
  const { data: products, isFetching, isError, refetch } = useUserProductsQuery();

  if (isFetching) {
    return <CircleLoading color={theme.colors.secondary.dark} size={8} />;
  }
  if (isError || !products || products.length === 0) {
    return (
      <ColumnContainer position="absolute" inset="0">
        <Typography fontWeight="bold" margin="1rem 0">
          {isError ? "Something went wrong, Please try Again." : "Your product list is empty!"}
        </Typography>
        <Button onClick={refetch}>{isError ? "Try Again" : "Refresh"}</Button>
      </ColumnContainer>
    );
  }
  return (
    <RowContainer wrap="wrap" align="flex-start" justify="flex-start" width="100%">
      {products.map(product => (
        <ProductCard key={product.softwareId} product={product} />
      ))}
    </RowContainer>
  );
};
